module.exports = __webpack_public_path__ + "static/img/mask2.0588def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask2.png
// module id = z4G3
// module chunks = 0